import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="contacts--no-postal-code"
//
// "No postal code available" on the Site Invoicing Info drawer (CONEK-8263),
// the Hotwire twin of the React BillingAccountDrawer checkbox: checking it puts
// the fixed value (React NO_POSTAL_CODE_VALUE, "N/A") in the postal code and
// DISABLES the field, as React does; unchecking clears and re-enables it.
//
// A disabled input is not submitted, so a hidden input of the same name carries
// "N/A" while checked (and is itself disabled otherwise) — the server receives
// exactly what React sends.
export default class extends Controller {
  static targets = ["input", "hidden", "checkbox"]
  static values = { value: String }

  connect() {
    this.apply(this.checkboxTarget.checked)
  }

  toggle() {
    const checked = this.checkboxTarget.checked
    this.inputTarget.value = checked ? this.valueValue : ""
    this.apply(checked)
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  apply(checked) {
    this.inputTarget.disabled = checked
    this.hiddenTarget.value = this.valueValue
    this.hiddenTarget.disabled = !checked
  }
}
